module.exports = __webpack_public_path__ + "img/c06_unittechlancerchampion_Normal_ua.d756eecd.webp";